import { takeLeading, select } from 'redux-saga/effects';
import { callApi } from 'helpers/saga-helpers';

import { makeSelectKeycloakToken } from 'containers/AppContainer/selectors';
import { REQUEST_EXISTANT_CLAIMS_FOR_LAWYER } from 'containers/LawyerDocumentsPage/constants';
import { setExistantClaims } from 'containers/ManagerDocumentsPage/actions';

export function* getExistantClaimsForLawyer(action: {
  status: string;
  type: string;
}): Generator<unknown> {
  const { status } = action;

  const token = yield select(makeSelectKeycloakToken());
  if (!token) return;

  const path = `/corporeal/existant-claim/existing-claim-lawyer-documents?status=${status}`;

  const options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };

  yield callApi(path, {}, options, [], setExistantClaims);
}

export function* getExistantClaimsForLawyerSaga() {
  yield takeLeading(
    REQUEST_EXISTANT_CLAIMS_FOR_LAWYER,
    getExistantClaimsForLawyer,
  );
}

export default [getExistantClaimsForLawyerSaga];
